import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Container } from '@proman/interfaces/entity-interfaces';
import { MasterCurrUser } from '../interfaces';
import { Store } from '@ngrx/store';
import { getCurrUser } from '@proman/store/curr-user';

@Component({
  selector: 'root-container-access',
  template: `
    <div class="hero">
      <root-header></root-header>
      <div class="container">
      </div>
    </div>
  `,
  styles: [`
      .container {
          margin-top: 5em;
          margin-bottom: 1em;
      }
      
      iframe {
          padding-top: 5em;
      }
  `]
})

export class ContainerAccessComponent implements OnInit {
  container: Container;
  currUser: MasterCurrUser;

  constructor(
    private Route: ActivatedRoute,
    private Router: Router,
    private store: Store,
  ) {
    this.store.select(getCurrUser).subscribe((user) => this.currUser = (user as any as MasterCurrUser));
    this.container = this.Route.snapshot.data['container'];
  }

  ngOnInit() {
    const url = `https://${this.container.namespace}.${this.container.domain}/api/master_login?_masterToken=${this.currUser.token}`;
    window.open(url, '_blank');
    this.Router.navigate(['containers']);
  }
}
